import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { InstallationUpdate } from "@/model/data/updates/InstallationUpdate";
import { PaginatedServiceResponseData } from "../PaginatedServiceResponseData";

export class FetchInstallationUpdatesStatusResponse extends PaginatedServiceResponseData {
  installationsList: InstallationUpdate[] = [];
  totalInstallationsCount: number;

  constructor(response: AxiosResponse) {
    super(response);
    if (response.data && response.data.Payload) {
      const data = response.data.Payload;

      data.DevicesUpdateStatus.forEach((v: any) => {
        var entry = new InstallationUpdate();
        entry.parse(v);
        this.installationsList.push(entry);
      });

      this.totalInstallationsCount = data.PaginatedTotalItems;
    }
  }
}
